module.exports = __webpack_public_path__ + "img/cores2.72063749.png";